import React, { useState, FC, useEffect } from 'react';
import { IVaultItem } from '@app/pages/passwordManager/interfaces';
import { Button } from '@material-ui/core';
import { useTypedTranslation } from '@app/hooks';

interface IAccordionProps {
    items: IVaultItem[];
    itemsReloaded: boolean;
    onFolderChoose: (vaultId: string, folderId: string) => void;
}

const VaultsAccordion: FC<IAccordionProps> = ({ items, itemsReloaded, onFolderChoose }) => {
    const { translation } = useTypedTranslation();
    const [activeVaultId, setActiveVaultId] = useState<string | null>();
    const [activeFolderId, setActiveFolderId] = useState<string | null>();

    const handleVaultClick = (vault: IVaultItem) => () => {
        const activeFolderId = vault.folders?.length ? vault?.folders[0].id : '';

        handleFolderChoose(vault.id, activeFolderId);
    };

    const handleFolderClick = (vaultId: string, folderId: string) => () => {
        handleFolderChoose(vaultId, folderId);
    };

    const handleFolderChoose = (vaultId: string, folderId: string) => {
        onFolderChoose(vaultId, folderId);
        setActiveFolderId(folderId);
        setActiveVaultId((prevIndex) => (prevIndex === vaultId ? prevIndex : vaultId));
        return;
    };

    useEffect(() => {
        if (itemsReloaded) {
            const firstVaultItem = items[0];
            const vaultId = firstVaultItem?.id;
            const activeFolderId = firstVaultItem?.folders?.length ? firstVaultItem?.folders[0].id : '';

            // automatically choose first vault and first folder
            if (firstVaultItem) {
                handleFolderChoose(vaultId, activeFolderId);
            }
        }
    }, [itemsReloaded]);

    return (
        <div className='vaults__list-accordion'>
            {items.map((item) => {
                return (
                    <div key={item.id}>
                        <Button
                            id='addVault'
                            name='addVault'
                            onClick={handleVaultClick(item)}
                            className={`vaults__item ${activeVaultId === item.id ? 'vaults__item-active' : ''}`}
                        >
                            <div className='vaults__item-icon'>
                                <i className='fa-regular fa-folder' aria-hidden='true' />
                            </div>
                            <div className='vaults__item-name'>{item.displayName}</div>
                            <div className={`vaults__item-arrow ${activeVaultId === item.id ? 'vaults__item-arrow-opened' : ''}`}>
                                <i className='fa-solid fa-chevron-up' aria-hidden='true' />
                            </div>
                        </Button>
                        {activeVaultId === item.id && (
                            <div>
                                {item.folders?.length ? (
                                    item.folders?.map((folder) => (
                                        <Button
                                            key={folder.id}
                                            className={`vaults__item child ${activeFolderId === folder.id ? 'vaults__item-active' : ''}`}
                                            onClick={handleFolderClick(item.id, folder.id)}
                                        >
                                            <div className='vaults__item-icon'>
                                                {folder.icon ? <i className={`icon-${folder.icon}`} aria-hidden='true' /> : null}
                                            </div>
                                            <div className='vaults__item-name'>{folder.displayName}</div>
                                        </Button>
                                    ))
                                ) : (
                                    <div className='table--empty'>{translation('VAULT_FOLDERS_EMPTY_LIST')}</div>
                                )}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default VaultsAccordion;
